<template>
    <div class="base-input-number-horizontal">
        <label style="color: rgba(63,72,204,1)" :title="name">
            {{title}}
            <span v-if="isRequired">*</span>
        </label>
        <span></span>
        <input class="e-input base-input-number-horizontal-input"
               ref="input"
               :disabled="disabled"
               :style="baseStyle"
               v-model.number="local_value"
               pattern="-?([0-9]*[.,]?[0-9]*?)?"
               :required="isRequired ? true : false"
               v-on:keydown.up="increaseVal"
               v-on:keydown.down="decreaseVal"
               @change="checkForValue" />
        <!--<p class="e-film-validation">Out of range</p>-->
    </div>
</template>

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        inheritAttrs: false,
        props: {
            isRequired: {
                type: Boolean,
                required: false,
                default: false
            },
            value: {
                type: Number,
                required: true
            },
            max: {
                type: Number,
                required: true,
            },
            min: {
                type: Number,
                required: true,
            },
            step: {
                type: Number,
                required: false,
            },
            title: {
                type: String,
                required: false
            },
            width: {
                type: Number,
                required: false,
                default: 50
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false
            },
            name: {
                type: String,
                required: false
            }
        },
        data() {
            return {
                local_value: this.value,
                baseStyle: { 'width': this.width + 'ch' } // use in CSS
            }
        },
        methods: {
            checkForValue() {
                if (this.local_value === "-") {
                    let value = this.$refs.input;
                    value.setCustomValidity("Error");
                }
            },
            increaseVal(event) {
                event.preventDefault();
                let val = parseFloat((this.local_value += this.step).toFixed(6));
                this.local_value = val;
            },
            decreaseVal() {
                let val = parseFloat((this.local_value -= this.step).toFixed(6));
                this.local_value = val;
            },
            numberValidation() {
                let value = this.$refs.input;
                value.setCustomValidity("");
                if (this.local_value == "-") {
                    if (this.min >= 0) {
                        value.setCustomValidity("Error");
                    }
                }
                else if (this.local_value == "") {
                    this.$emit('change', 0)
                }
                else if (this.min <= this.local_value && this.local_value <= this.max) {
                    this.$emit('change', this.local_value)
                } else {
                    value.setCustomValidity("Error");
                }
            },
        },
        watch: {
            "local_value": {
                handler: function () {
                    this.numberValidation();
                }
            },
        }
    })
</script>

<style scoped>
    .base-input-number-horizontal {
        display: flex;
        text-align: center;
        line-height: 40px;
        margin: 5px 20px;
    }

    .base-input-number-horizontal-input {
        margin-left: 10px;
    }

    .e-input {
        appearance: textfield;
        &::-webkit-inner-spin-button

        {
            -webkit-appearance: none;
        }
    }

    .film-input-validation {
        color: red;
        position: absolute;
        bottom: 0px;
    }
</style>